import common from "@well-b/well-b-shared";
import {dateRangeFieldConfig} from "../../../admin/AdminReports/consts.js";

export const systemReports = [
    {
        key: common.report.ReportName.COMPANIES_REPORT,
        value: common.report.ReportsNameToText[common.report.ReportName.COMPANIES_REPORT],
        fields: dateRangeFieldConfig(true)
    }
];
